export default function RefluxMixin(ParentClass) {
  return class RefluxMixin extends ParentClass {
    constructor(props) {
      super(props);
      this._storeListeners = [];
      this._actionListeners = [];
    }

    listenToStores() {
      if (super.listenToStores) {
        super.listenToStores();
      }
    }

    listenToStore(store, key) {
      if (key) {
        this._storeListeners.push(
          store.listen(this._changeListenerWithKey.bind(this, key))
        );
        const data = {};
        data[key] = store.getInitialState();
        this.setState(data);
      } else {
        this._storeListeners.push(
          store.listen(this._changeListener.bind(this))
        );
        this.setState(store.getInitialState());
      }
    }

    listenToStoreWithSelector(store, selector) {
      this._storeListeners.push(
        store.listen(this._changelistenerWithSelector.bind(this, selector))
      );
      this.setState(store.getInitialState());
    }

    shallowEquals(subState, state) {
      return Object.keys(subState).every(key => {
        return subState[key] === state[key];
      });
    }

    listenToStoreWithMapper(store, mapper, initial) {
      this._storeListeners.push(
        store.listen(state => {
          const newState = mapper(state);
          if (!this.shallowEquals(newState, this.state)) {
            this.setState(newState);
          }
        })
      );
      const state = { ...initial, ...mapper(store.getInitialState()) };
      this.setState(state);
    }

    listenToActions() {
      if (super.listenToActions) {
        super.listenToActions();
      }
    }

    mapActions(actions) {
      const boundActions = {};
      Object.keys(actions).forEach(actionName => {
        const action = actions[actionName];
        boundActions[actionName] = function() {
          return action(...arguments);
        };
      });
      return boundActions;
    }

    listenToAction(action, callback) {
      action && this._actionListeners.push(action.listen(callback));
    }

    _changeListenerWithKey(key, data) {
      const updateObject = {};
      updateObject[key] = data;
      this.setState(updateObject);
    }

    _changelistenerWithSelector(selector, data) {
      const updateObject = Object.keys(selector).reduce((prev, current) => {
        prev[selector[current]] = data[current];
        return prev;
      }, {});
      this.setState(updateObject);
    }

    _changeListener(data) {
      this.setState(data);
    }

    componentWillMount() {
      if (super.componentWillMount) {
        super.componentWillMount();
      }
      this.listenToStores();
      this.listenToActions();
    }

    componentWillUnmount() {
      if (super.componentWillUnmount) {
        super.componentWillUnmount();
      }
      this._storeListeners.forEach(unsub => unsub());
      this._actionListeners.forEach(unsub => unsub());
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/Util/RefluxMixin.js